"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const builders = __importStar(require("./builders"));
const Builder_1 = __importDefault(require("../Builder"));
class Two3Builder extends Builder_1.default {
    constructor() { super(); }
    buildSummary(data) {
        let cqLayout = [
            [
                "User Name",
                "Thermocycler",
                "Run Name",
                "Date",
                "Sample Name",
                "Well Number",
                "Fluorophore",
                "Cq",
                "Threshold"
            ]
        ];
        data.forEach(item => {
            const { run, user } = item;
            const { version, name, timestamp } = run;
            run.targets.forEach(target => {
                cqLayout.push([
                    user.username,
                    version.serialNumber,
                    name,
                    timestamp,
                    target.sampleName,
                    target.wellNumber + 1,
                    target.color,
                    target.cq,
                    target.threshold
                ]);
            });
        });
        return cqLayout;
    }
    buildDetailed(data) {
        let sheetNames = {};
        let builtData = data.map((item) => {
            return {
                header: builders.header(item),
                wellInfo: builders.wellInfo(item),
                baselineData: builders.baselineData(item, true),
                rawData: builders.rawData(item, true),
                protocol: builders.protocol(item),
                standard: builders.standard(item, item.run.runType),
                location: builders.location(item),
                notes: builders.notes(item, true),
                optional: builders.optional(item.optional),
                version: builders.version(item),
                sheetName: builders.sheetName(item, sheetNames)
            };
        });
        return builtData;
    }
    layout(item) {
        const SPACE = [null];
        return [
            ...item.header,
            SPACE,
            ...item.wellInfo,
            SPACE,
            ...item.baselineData,
            SPACE,
            ...item.rawData,
            SPACE,
            ...item.version,
            SPACE,
            ...item.standard,
            SPACE,
            ...item.protocol,
            SPACE,
            ...item.location,
            SPACE,
            ...item.notes,
            SPACE,
            ...item.optional
        ];
    }
}
exports.default = Two3Builder;
